import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { UnitAvatar } from "../components/UnitAvatar.js";
import { ROLE_COLOR } from "../lib/unitName.js";
function DemoCard({ role, label, isHit, isSkilling, hitCount, skillCount }) {
    const color = ROLE_COLOR[role];
    const bg = isHit ? "#3d0808" : "#12121a";
    const borderCol = isHit ? "#ef4444" : isSkilling ? color : color + "44";
    const shadow = isHit
        ? "0 0 0 2px #ef4444, 0 0 24px #ef444499"
        : isSkilling
            ? `0 0 0 2px ${color}, 0 0 24px ${color}99`
            : "none";
    return (_jsxs("div", { style: {
            background: bg,
            border: `2px solid ${borderCol}`,
            borderRadius: 10,
            padding: "10px 12px",
            width: 140,
            boxShadow: shadow,
            transition: isHit || isSkilling
                ? "none"
                : "background 0.4s ease-out, border-color 0.4s ease-out, box-shadow 0.45s ease-out",
        }, children: [_jsxs("div", { style: {
                    display: "flex", alignItems: "center", gap: 8, marginBottom: 8,
                    animation: (hitCount + skillCount) > 0 ? "unitShake 0.3s ease-out" : "none",
                }, children: [_jsx(UnitAvatar, { role: role, size: 28 }), _jsx("span", { style: { color, fontWeight: 700, fontSize: 13 }, children: label })] }, `${hitCount}-${skillCount}`), _jsx("div", { style: { background: "#0a0a0f", borderRadius: 3, height: 6 }, children: _jsx("div", { style: { width: "65%", height: "100%", background: "#22c55e", borderRadius: 3 } }) }), _jsx("div", { style: { marginTop: 6, fontSize: 10, color: isHit ? "#ef4444" : isSkilling ? color : "#475569", fontWeight: 700 }, children: isHit ? "● HIT" : isSkilling ? "● SKILL" : "○ idle" })] }));
}
const SEQUENCE = [
    { hit: "tank", skill: null },
    { hit: null, skill: "striker" },
    { hit: "hacker", skill: null },
    { hit: null, skill: "support" },
    { hit: "striker", skill: null },
    { hit: null, skill: "tank" },
    { hit: "support", skill: null },
    { hit: null, skill: "hacker" },
];
export function AnimTestScreen() {
    const [step, setStep] = useState(0);
    const [counts, setCounts] = useState({
        tank: { hit: 0, skill: 0 },
        striker: { hit: 0, skill: 0 },
        hacker: { hit: 0, skill: 0 },
        support: { hit: 0, skill: 0 },
    });
    useEffect(() => {
        const id = setInterval(() => {
            setStep(s => {
                const next = (s + 1) % SEQUENCE.length;
                const seq = SEQUENCE[next];
                setCounts(prev => {
                    const c = { ...prev };
                    if (seq.hit)
                        c[seq.hit] = { ...c[seq.hit], hit: c[seq.hit].hit + 1 };
                    if (seq.skill)
                        c[seq.skill] = { ...c[seq.skill], skill: c[seq.skill].skill + 1 };
                    return c;
                });
                return next;
            });
        }, 800);
        return () => clearInterval(id);
    }, []);
    const cur = SEQUENCE[step];
    const roles = ["tank", "striker", "hacker", "support"];
    return (_jsxs("div", { style: { padding: 24, display: "flex", flexDirection: "column", gap: 24 }, children: [_jsx("div", { style: { color: "#7c3aed", fontWeight: 900, fontSize: 16, letterSpacing: 2 }, children: "ANIMATION TEST" }), _jsxs("div", { style: { color: "#475569", fontSize: 12 }, children: ["step ", step + 1, "/", SEQUENCE.length, " \u00B7 800ms interval"] }), _jsx("div", { style: { display: "flex", flexWrap: "wrap", gap: 12 }, children: roles.map(role => (_jsx(DemoCard, { role: role, label: role, isHit: cur.hit === role, isSkilling: cur.skill === role, hitCount: counts[role].hit, skillCount: counts[role].skill }, role))) }), _jsxs("div", { style: { background: "#12121a", borderRadius: 8, padding: 12, fontSize: 11, color: "#64748b" }, children: [_jsx("div", { children: "\u0415\u0441\u043B\u0438 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u2014 \u0432\u0438\u0434\u0438\u0448\u044C:" }), _jsx("div", { style: { color: "#ef4444", marginTop: 4 }, children: "\u25CF \u041A\u0440\u0430\u0441\u043D\u044B\u0439 \u043E\u0431\u043E\u0434\u043E\u043A + \u0441\u0432\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u0438 HIT" }), _jsx("div", { style: { color: "#f59e0b", marginTop: 2 }, children: "\u25CF \u0426\u0432\u0435\u0442\u043D\u043E\u0439 \u043E\u0431\u043E\u0434\u043E\u043A \u043F\u0440\u0438 SKILL" }), _jsx("div", { style: { color: "#94a3b8", marginTop: 2 }, children: "\u25CF Shake \u0430\u043D\u0438\u043C\u0430\u0446\u0438\u044F \u043D\u0430 \u0430\u0432\u0430\u0442\u0430\u0440\u0435" })] })] }));
}
